import { Property } from "./interfaces";

export const fechaDispensAdmon: Property = {
  title: "Fecha de Dispensación Administración",
  type: "string",
  format: "local-date-time",
};
